module.exports = __webpack_public_path__ + "static/use-case-5-content-5-b-d0f69c6fef64fb73ba1800c2ca45e12a.png";